import { Component, OnInit } from "@angular/core";
import { NavController, Platform } from "@ionic/angular";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { BaseService } from "./base/service//base.service";
import { UxService } from "./project/services/ux.service";
import {
  NavigationExtras,
  Router,
  NavigationEnd,
  ActivatedRoute,
  ParamMap,
} from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  selectedPage: any;
  appPages: any[];
  year: any;
  currentUrl: string;
  rutRouteParams: any;
  correoRouteParams: any;

  constructor(
    private navController: NavController,
    private platform: Platform,
    private baseService: BaseService,
    private uxService: UxService,
    private statusBar: StatusBar,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    const urlParams = new URLSearchParams(globalThis.location.search);
    const token = urlParams.get('token');
    if (token) {
      localStorage.setItem('ms_token', token);
    }
    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString("#003c58");
    this.appPages = [];
    this.initalizeApp();
  }
  ngOnInit() {}

  async initalizeApp() {
    this.platform.ready().then(() => {
      this.initHomePage();
    });
  }

  async selectMenuItem(page: any) {
    const params: NavigationExtras = {
      state: {
        pageActive: page,
      },
    };
    this.selectedPage = page;
    this.navController.navigateRoot(this.selectedPage.metodo, params);
  }

  async initHomePage() {
    try {
      await this.getParams();
      if (this.rutRouteParams || this.correoRouteParams) {
        this.router.navigate(["/qr"], {
          queryParams: { rut: this.rutRouteParams, correo: this.correoRouteParams },
        });
      } else {
        this.router.navigate(["/qr"]);
      }
    } catch (error) {}
  }
  private getParams() {
    return new Promise<void>((resolve) => {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (this.activatedRoute.snapshot.queryParams.rut) {
            this.rutRouteParams = this.activatedRoute.snapshot.queryParams.rut;
            this.correoRouteParams =
              this.activatedRoute.snapshot.queryParams.correo;
            const token = this.activatedRoute.snapshot.queryParams.token;
            if (token) {
              localStorage.setItem('ms_token', token);
            }
            resolve();
          }
        }
      });
    });
  }
}
